import { Helmet } from 'react-helmet-async';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import BlogNewEditForm from '../blog-new-edit-form';

// ------------------------------------------------------------- ---------

export default function BlogCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new blog"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Blog',
            href: paths.dashboard.blog.root,
          },
          {
            name: 'New Blog',
          }, 
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BlogNewEditForm />
    </Container>
  );
}